import { render, staticRenderFns } from "./target.vue?vue&type=template&id=9b8ea048&"
import script from "./target.vue?vue&type=script&lang=ts&"
export * from "./target.vue?vue&type=script&lang=ts&"
import style0 from "./target.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports